import {Injectable} from '@angular/core';
import {EventDispatcher} from "../../utils/event-dispatcher/event-dispatcher";
import {BehaviorSubject} from "rxjs/internal/BehaviorSubject";

@Injectable()
export class GlobalEventDispatcherService {

  private readonly _dispatcher: EventDispatcher;
  vibeGenerateDialog$ = new BehaviorSubject<() => void | null>(null);

  constructor() {
    this._dispatcher = new EventDispatcher();
  }

  public addEventListener(event: string, listener: any, context: any = null): void {
    this._dispatcher.addEventListener(event, listener, context);
  }

  public removeEventListener(event: string, listener: any): void {
    this._dispatcher.removeEventListener(event, listener);
  }

  public removeAllListeners(event: string): void {
    this._dispatcher.removeAllListeners(event);
  }

  public dispatchEvent(event: string, ...args: any[]): void {
    this._dispatcher.dispatchEvent.apply(this._dispatcher, [event].concat(args));
  }

}
